import {themeConstants} from "../constants/themeConstants";

export const themeActions = {
    setDarkMode
};

function setDarkMode(isDarkMode) {
    return dispatch => {
        try {
            localStorage.setItem(themeConstants.STORAGE_KEY, JSON.stringify(isDarkMode));
        } catch {
            // The theme can still change when browser storage is unavailable.
        }
        return dispatch({type: themeConstants.SET_DARK_MODE, isDarkMode});
    };
}
